export default [
  // 班级放学全量
  {
    path: '/afterschool/index',
    name: 'PageAfterSchoolIndex',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/afterschool/PageAfterSchoolIndex'
      ),
    meta: { modular: 30, title: '班级放学', info: '班级放学-首页' }
  },
  {
    path: '/afterschool/headermaster',
    name: 'PageAfterSchoolIndex',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/afterschool/PageAfterSchoolIndex'
      ),
    meta: { modular: 30, title: '班级放学', info: '班级放学-班主任首页' }
  },
  {
    path: '/full/afterschool/setting',
    pathType: 'keep',
    name: 'PageAfterSchoolSetting',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/afterschool/PageAfterSchoolSetting'
      ),
    meta: { modular: 30, title: '设置', info: '班级放学——设置' }
  },
  {
    path: '/afterschool/chooseDeverice',
    name: 'PageChooseDeverice',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/afterschool/PageChooseDeverice'
      ),
    meta: { modular: 30, title: '选择设备', info: '班级放学——选择设备' }
  },
  {
    path: '/full/afterschool/set/plan',
    pathType: 'keep',
    name: 'PageLeaveSetPlan',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/afterschool/PageLeaveSetPlan'
      ),
    meta: {
      modular: 30,
      title: '学生放学计划',
      info: '班级放学——设备启用时间',
      keepAlive: true
    }
  },
  {
    path: '/afterschool/notice',
    name: 'PageAfterSchoolNotice',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/afterschool/PageAfterSchoolNotice'
      ),
    meta: { modular: 30, title: '通知配置', info: '班级放学——通知配置' }
  },
  {
    path: '/afterschool/noticeDetail',
    name: 'PageAfterSchoolNoticeDetail',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/afterschool/PageAfterSchoolNoticeDetail'
      ),
    meta: { modular: 30, title: '通知配置', info: '班级放学——编辑通知配置' }
  },
  {
    path: '/afterschool/student/chooseDeverice',
    name: 'PageAfterSchoolStudentChooseDeverice',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/afterschool/PageAfterSchoolStudentChooseDeverice'
      ),
    meta: { modular: 30, title: '选择设备', info: '班级放学——等候区刷脸设备' }
  },
  {
    path: '/afterschool/guardian',
    name: 'PageGuardianAfterSchool',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/afterschool/PageGuardianAfterSchool'
      ),
    meta: { modular: 30, title: '班级放学', info: '班级放学——家长首页' }
  },

  // 学生留堂
  {
    path: '/afterschool/detention/index',
    name: 'PageDetention',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/afterschool/PageDetention'
      ),
    meta: { modular: 31, title: '学生留堂', info: '学生留堂-首页' }
  },
  {
    path: '/afterschool/detention/face',
    name: 'PageFaceDetention',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/afterschool/PageFaceDetention'
      ),
    meta: { modular: 31, title: '学生留堂', info: '学生留堂——人脸识别' }
  },
  {
    path: '/full/afterschool/plan/time',
    pathType: 'keep',
    name: 'PageLeaveSetPlanTime',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/afterschool/PageLeaveSetPlanTime'
      ),
    meta: { modular: 30, title: '放学时段', info: '班级放学——设置' }
  },
  {
    path: '/gray/afterschool/setting',
    pathType: 'keep',
    name: 'PageAfterSchoolSetting',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/afterschool/gray/PageAfterSchoolSetting'
      ),
    meta: { modular: 30, title: '设置', info: '班级放学——设置' }
  },
  {
    path: '/gray/afterschool/set/plan',
    pathType: 'keep',
    name: 'PageLeaveSetPlan',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/afterschool/gray/PageLeaveSetPlan'
      ),
    meta: {
      modular: 30,
      title: '学生放学计划',
      info: '班级放学——设备启用时间',
      keepAlive: true
    }
  },
  {
    path: '/gray/afterschool/plan/time',
    pathType: 'keep',
    name: 'PageLeaveSetPlanTime',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/afterschool/gray/PageLeaveSetPlanTime'
      ),
    meta: { modular: 30, title: '放学时段', info: '班级放学——设置' }
  }
]
